import { ApplicationError } from '@/src/shared/errors';

export class OutletListNotFoundError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal memuat data outlet silahkan coba beberapa saat lagi');
  }
}

export class ProductListNotFoundError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal memuat data produk silahkan coba beberapa saat lagi');
  }
}

export class ServiceListNotFoundError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal memuat data layanan silahkan coba beberapa saat lagi'
    );
  }
}

export class ProvinceNotFoundError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal memuat data provinsi silahkan coba beberapa saat lagi'
    );
  }
}

export class ProductTypeNotFoundError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal memuat data tipe produk silahkan coba beberapa saat lagi'
    );
  }
}
